import { AppState } from '../store';
import * as modules from '../modules/identification';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { updateParameter } from '../modules/identification/actions';
import { connect } from 'react-redux';
import IdentificationByBirth from '../components/IdentificationByBirth';

export const mapStateToProps = (state: AppState) => {
  return {
    birthday: modules.Selectors.getBirthday(state),
    status: state.identification.status,
    organizationId: state.property.property.organizationId || '',
    usageInfoId: state.property.property.usageInfoId
  };
};

export const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, {}, AnyAction>
) => ({
  updateParameter: (
    key: string,
    value: string | number | boolean | undefined
  ) => dispatch(updateParameter(key, value)),
  verifyIdentification: (organizationId: string, usageInfoId: string) =>
    dispatch(
      modules.operations.verifyIdentification(organizationId, usageInfoId)
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdentificationByBirth);
